<template>
  <!-- 1️⃣ DEMANDE DE CODE -->
  <form v-if="step === 'request'" @submit.prevent="sendResetLink" class="form-group">
    <label>Email ou téléphone</label>
    <input
      type="text"
      v-model="identifier"
      :disabled="loading"
      required
      placeholder="Email ou téléphone"
    />
    <div class="btn-group">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="loading"
        :aria-busy="loading"
      >
  <span v-if="loading" class="btn-loader">
    <span class="spinner" aria-hidden="true"></span>
    Chargement...
  </span>
  <span v-else>Vérifier le code</span>

        <!--<span v-if="loading">Envoi...</span>
        <span v-else>Envoyer le code</span>-->
      </button>
    </div>
  </form>

  <!-- 2️⃣ VÉRIFICATION DU CODE -->
  <form v-if="step === 'verify'" @submit.prevent="verifyCode" class="form-group">
    <label>Email ou téléphone</label>
    <input
      type="text"
      v-model="identifier"
      :disabled="identifierLocked || loading"
      required
      placeholder="Email ou téléphone"
    />
    <label>Code de vérification</label>
    <input
      type="text"
      v-model="verificationCode"
      :disabled="loading"
      required
      placeholder="Code reçu"
    />
    <div class="btn-group">

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="loading"
        :aria-busy="loading"
      >
  <span v-if="loading" class="btn-loader">
    <span class="spinner" aria-hidden="true"></span>
    Chargement...
  </span>
  <span v-else>Vérifier le code</span>
      </button>
    </div>
  </form>

  <!-- 3️⃣ RESET PASSWORD -->
  <form v-if="step === 'reset'" @submit.prevent="resetPassword" class="form-group">
    <PasswordField ref="passwordField" />
    <div class="btn-group">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="loading"
        :aria-busy="loading"
      >
        <span v-if="loading">Modification...</span>
        <span v-else>Changer le mot de passe</span>
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toast-notification'
import { storeToRefs } from 'pinia'
import PasswordField from '@/components/PasswordField.vue'
import { config } from '@/config/env.js'
import { useLocaleStore } from '@/stores/localeStore'

const route = useRoute()
const router = useRouter()
const toast = useToast()
const localeStore = useLocaleStore()
const { countryIso } = storeToRefs(localeStore)

const identifier = ref('')
const verificationCode = ref('')
const step = ref('request')
const passwordField = ref(null)
const identifierLocked = ref(false)
const loading = ref(false)

const stepTitle = computed(() => {
  if (step.value === 'request') return 'Mot de passe oublié'
  if (step.value === 'verify') return 'Vérification du code'
  return 'Nouveau mot de passe'
})

onMounted(() => {
  if (route.params.verificationCode) {
    verificationCode.value = route.params.verificationCode
    step.value = 'verify'
  }
})

async function sendResetLink() {
  if (loading.value) return

  loading.value = true

  try {
    const res = await fetch(config.apiUrl + '/password/forgot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        identifier: identifier.value,
        countryIso: countryIso.value,
      }),
    })

    if (!res.ok) throw new Error('Erreur lors de l’envoi')

    toast.success('Code envoyé')
    step.value = 'verify'
    identifierLocked.value = true
  } catch (err) {
    toast.error(err.message)
  } finally {
    loading.value = false
  }
}

async function verifyCode() {
  if (loading.value) return

  loading.value = true

  try {
    const res = await fetch(config.apiUrl + '/password/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        identifier: identifier.value,
        verificationCode: verificationCode.value,
        countryIso: countryIso.value,
      }),
    })

    if (!res.ok) throw new Error('Code invalide')

    toast.success('Code valide')
    step.value = 'reset'
  } catch (err) {
    toast.error(err.message)
    step.value = 'verify'
  } finally {
    loading.value = false
  }
}

async function resetPassword() {
  if (loading.value) return

  const values = passwordField.value.getValues()

  if (!values.isValid) {
    toast.error('Mot de passe invalide')
    return
  }

  loading.value = true

  try {
    const res = await fetch(config.apiUrl + '/password/reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        identifier: identifier.value,
        verificationCode: verificationCode.value,
        newPassword: values.password,
        verifyPassword: values.verifyPassword,
        countryIso: countryIso.value,
      }),
    })

    if (!res.ok) throw new Error('Erreur lors du changement')

    toast.success('Mot de passe modifié avec succès')
    router.push({ name: 'login' })
  } catch (err) {
    toast.error(err.message)
  } finally {
    loading.value = false
  }
}
</script>
